import { useEffect, useState } from "react"

import { Form, Input } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../Button"
import PasswordValidator from "../PasswordValidator"

function NewPasswordForm({ error, ...props }) {
  const [value, setValue] = useState(null)
  const [valueConfirm, setValueConfirm] = useState(null)
  const [errorText, setErrorText] = useState(null)

  const [form] = Form.useForm()
  const { t } = useTranslation()

  useEffect(() => {
    if (error) {
      if (typeof error === "string") {
        if (error.length > 100) {
          setErrorText(t("Server response error"))
        } else {
          setErrorText(error)
        }
      } else {
        setErrorText(Object.values(error)[0])
      }
    }
  }, [error])

  const onFinish = (values) => {
    const data = { ...values }
    props.onSubmit(data.password)
  }

  const onFinishFailed = ({ errorFields }) => {
    if (errorFields) setErrorText(errorFields[0]["errors"])
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
    setErrorText(null)
  }

  function onFocusHandler(e) {
    const target = e.target
    handleClearError(e, target.name)
  }

  function handleChange(e) {
    const { name, value } = e.target
    if (name === "password") setValue(value)
    if (name === "confirm") setValueConfirm(value)
  }

  return (
    <Form
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      validateTrigger="onSubmit"
      className="login-form"
      layout="vertical"
      form={form}
      requiredMark={false}
    >
      <Form.Item
        name="password"
        validateStatus={errorText ? "error" : null}
        rules={[{ required: true, message: "Required field" }]}
        style={{ marginBottom: 8 }}
      >
        <Input.Password
          name="password"
          placeholder={`${t("New Password")}...`}
          autoComplete="dontshow"
          visibilityToggle
          onChange={(e) => handleChange(e)}
          onFocus={(e) => onFocusHandler(e)}
        />
      </Form.Item>

      <PasswordValidator value={value} error={errorText} isLogin={true} />

      <Form.Item
        name="confirm"
        style={{ marginBottom: 0 }}
        rules={[
          {
            required: true,
            message: "Please confirm your password!"
          },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || !getFieldValue("password") || getFieldValue("password") === value) {
                if (value?.length < 8) {
                  return Promise.reject("Must be at least 8 characters")
                } else {
                  return Promise.resolve()
                }
              } else {
                return Promise.reject("Passwords do not match")
              }
            }
          })
        ]}
      >
        <Input.Password
          name="confirm"
          placeholder={`${t("Confirm new password")}...`}
          autoComplete="dontshow"
          visibilityToggle
          onChange={(e) => handleChange(e)}
          onFocus={(e) => onFocusHandler(e)}
        />
      </Form.Item>

      <ButtonComponent
        type="primary"
        htmlType="submit"
        size="large"
        block
        disabled={!valueConfirm || value?.length < 6 || valueConfirm?.length < 6}
      >
        {t("Reset password")}
      </ButtonComponent>
    </Form>
  )
}

export default NewPasswordForm
